import React, { useState } from 'react';
import { Row, Col, Input, Modal, Typography } from 'antd';
import { identity, startCase } from 'lodash';
import PdButton from 'components/pd-button';

const { Text } = Typography;

export function SecretCodeModal({
  onCancel = identity,
  orderDetail: {
    id,
    invoice_number,
    pickup_point: { title: pickupPointTitle } = {},
    user: { first_name, last_name } = {},
    warehouse: { title: warehouseTitle } = {},
  } = {},
  onSubmit = identity,
  open,
}) {
  const [secretCode, setSecretCode] = useState('');

  function handleOnChangeSecretCode({ target: { value } } = {}) {
    setSecretCode(value);
  }

  const FIELDS_VALUES = [
    {
      field: 'Invoice Number',
      value: (
        <Text className="pd-color-primary" strong>
          {invoice_number}
        </Text>
      ),
    },
    {
      field: 'Order No',
      value: <Text strong>{id}</Text>,
    },
    {
      field: 'Customer Name',
      value: (
        <Text strong>
          {startCase([first_name, ' ', last_name].filter((name) => name))}
        </Text>
      ),
    },
    {
      field: 'Warehouse',
      value: <Text strong>{warehouseTitle}</Text>,
    },
    {
      field: 'Pick Up Point',
      value: <Text strong>{pickupPointTitle}</Text>,
    },
    {
      field: 'Secret Code',
      value: (
        <Input
          placeholder="Enter Secret Code"
          onChange={handleOnChangeSecretCode}
          value={secretCode}
        />
      ),
    },
  ];

  return (
    <Modal
      centered
      footer={null}
      onCancel={onCancel}
      title="Secret Code"
      open={open}>
      <Row className="pd-margin-bottom-md">
        {FIELDS_VALUES.map(({ field, value }, idx) => (
          <Col span={24} key={idx}>
            <Row gutter={[18, 36]}>
              <Col span={6} offset={4}>
                {field}
              </Col>
              <Col span={12}>{value}</Col>
            </Row>
          </Col>
        ))}
      </Row>
      <Row type="flex" justify="center">
        <Col span={12}>
          <PdButton
            full
            onClick={() => onSubmit({ pickup_code: secretCode })}
            type="primary">
            Submit
          </PdButton>
        </Col>
      </Row>
    </Modal>
  );
}
